import { getEnvironmentUrlApiV2 } from './getEnvironmentUrlApiV2';

export const getTeamsWithContent = (
  authToken: string,
  environment: Parameters<typeof getEnvironmentUrlApiV2>[0],
): Promise<unknown> =>
  fetch(`${getEnvironmentUrlApiV2(environment)}team/contentgroups/?contentType=video`, {
    method: 'GET',
    headers: new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authToken}`,
    }),
  }).then((res) => res.json());
